import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  dialogPaper: {
    maxWidth: 670,
    height: '100%',
    maxHeight: 524,

    [theme.breakpoints.down('xs')]: {
      width: '100%',
      alignSelf: 'flex-end',
      borderRadius: '18px 18px 0 0',
      margin: 0,
      height: '72%',
      maxHeight: '100%',
    },
  },
  dialogTitle: {
    width: '100%',
    padding: '17px 24px',
    border: '1px solid #ECEFF1',

    display: 'flex',
    alignItems: 'center',
  },
  dialogTitleCloseBtn: {
    position: 'absolute',
    right: theme.spacing(2),
    top: theme.spacing(2),
  },
  dialogTitleCloseIcon: {
    '& > svg': {
      color: '#37474F',
    },
  },
  dialogContent: {
    padding: '24px 20px',
  },
  dialogContentHeader: {
    background: '#ECEFF1',
    padding: '12px 17px',
    borderRadius: 4,

    display: 'flex',
    alignItems: 'center',
  },
  avatarIcon: {
    marginRight: theme.spacing(1),
  },
  affiliateName: {
    color: '#546E7A',
    fontWeight: 400,
  },
  loadingContainer: {
    textAlign: 'center',
    width: '100%',
    height: '100%',
    padding: theme.spacing(2),

    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));
